export const getDateTimes = (dates:string[]) =>{
    return dates.map(string => {
        const dateValues = string.split('-')
        const year = +dateValues[0]
        const month = +dateValues[1] - 1
        const day = +dateValues[2].slice(0, 2)
        const date = new Date(year, month, day)
        return date.getTime()
    })
}